import { Component } from '@angular/core';
import { take, catchError } from 'rxjs/operators';
import { ProductClass } from '../../models/product-class.model';
import { ProductClassService } from '../../services/product-class.service';
import { ProductClassValidatorService } from '../../validators/product-class-validator.service';

@Component({
    selector: 'app-product-classes-new',
    templateUrl: './product-classes-new.component.html',
    styleUrls: ['./product-classes-new.component.scss'],
    standalone: false
})
export class ProductClassesNewComponent {

  productClass: ProductClass = new ProductClass();

  isError: boolean = false;
  isServerError: boolean = false;

  constructor(private productClassValidator: ProductClassValidatorService,
    private productClassService: ProductClassService) { }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;

    if (this.productClassValidator.isValid(this.productClass)) {
      this.productClassService.createProductClass(this.productClass)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        window.location.href = '/warehousing/product-classes';
      })
    } else {
      this.isError = true;
    }
  }
}
